import { defa } from 'defa-object';

/**
 * defa.views.UnitSearchHelpView
 * A view for helping end users and installers understand how a serial number works.
 * @version 1.0.1
 */
import View     from 'scripts/poppet/view';
import template from 'templates/unitSearchHelpView.jst.html'

const selectors          = {
	container      : '[data-container=serial-help]',
	buttonNewDevice: '[data-click="new-device"]',
};
const UnitSearchHelpView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: '',
	
	ui: {
		container: selectors.container,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers after first render, before the view is attached to the DOM.
	 * @void
	 */
	onBeforeAttach: function () {
		let self         = this,
			languageCode = defa.objects.languageSettings.shortLanguage;
		
		// there are no french translations
		if ( 'fr' === languageCode ) {
			languageCode = 'en';
		}
		
		let url = `${defa.vars.base}assets/scripts/helps/serial-help-${languageCode}.html`;
		
		$.get( url )
		 .done( function ( response ) {
			
			 // add the article
			 self.ui.container.append( response );
			
			 // activate the "Enter Serial Number" buttons
			 $( selectors.buttonNewDevice ).on( 'click', function ( event ) {
				 event.preventDefault();
				 self.trigger( 'nav', 'unit:search:serial' );
			 } );
			
		 } );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitSearchHelpView;